import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useCustomersList() {
  // Use toast
  const toast = useToast();

  const refCustomerListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: "user_number", label: "編號", sortable: true, class: 'sticky-column' },
    { key: "name_cn", label: "單據抬頭", sortable: true, class: 'sticky-column' },
    { key: "actions", label: "操作", class: 'sticky-column' },
    { key: "name", label: "系統帳號名稱", sortable: true },
    { key: "locked", label: "封鎖"},
    { key: "locked_reason", label: "禁⽤客⼾原因"},
    { key: "is_active", label: "狀態" },
    { key: "phone", label: "聯絡電話" },
    // { key: "phone2", label: "備用電話號碼" },
    { key: "email", label: "電郵地址"},
    { key: "customer_addresses", label: "地址"},
    { key: "roles", label: "權限"},
    /* { key: "creator", label: "建立者", sortable: true }, */
    { key: "created_at", label: "創建日期", sortable: true },
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refCustomerListTable.value
      ? refCustomerListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    // refCustomerListTable.value.refresh();
    fetchCustomers()
  };

  const customersList = ref(null);

  watch(
    [currentPage, perPage, searchQuery],
    () => {
      refetchData();
    }
  );

  const fetchCustomers = (ctx, callback) => {

   /*  customersList.value = [{
        id:"CS0081",
        "name_cn": "陳大文先生",
        "name_en": "Mr. Chan Tai Man",
        "tel": "91234567",
        "email": "chantaiman@gmail.com",
        "address":"新界粉嶺",
        "creador":"Wing So",
        "created_at":"17-07-2022,13:00"
      }] */
     store
       .dispatch("customer/fetchCustomers", {
         q: searchQuery.value,
         perPage: perPage.value,
         page: currentPage.value,
         sortBy: sortBy.value,
         sortDesc: isSortDirDesc.value,
         //gender_id: filter_gender_id.value,
         //bank_id: filter_bank_id.value,
         //payment_method_id: filter_payment_method_id.value,
         //customer_status_id: filter_customer_status.value,
       })
       .then((response) => {
        console.log('customer/fetchCustomers')
         const { entities, total } = response.data;
         console.log({entities})
         //callback(entities);
         
         totalRow.value = total;
         customersList.value = entities
       })
       .catch((err) => {
         console.log(err);
         toast({
           component: ToastificationContent,
           props: {
             title: "獲取貸款清單時出錯",
             icon: "AlertTriangleIcon",
             variant: "danger",
           },
         });
       });
  };

  onMounted(() => {
    refetchData();
  });

  return {
    fetchCustomers,
    tableColumns,
    perPage,
    currentPage,
    totalRow,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    customersList,
    refCustomerListTable,
    ability,
    refetchData,
  };
}
